// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1o47B","errorLogs":"EditorFooter_errorLogs__1505T"};